export default {
  "base": [
    {
      "questionsType": "饮食情况",
      "questionList": [{
        "questionType": "radio",
        "question": "饮水情况",
        "options": ["饮水多", "饮水少","口渴但不想喝水", "口渴想大量喝水","正常"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "喜欢喝",
        "options": ["冰凉水", "温热水","无偏好"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "口中感觉",
        "options": ["甜", "苦","热","麻","酸","咸","淡","晨起口苦","口唇干燥","涎唾过多","正常"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "胃口",
        "options": ["较好", "一般","较差","吃得多但易饿","想吃但吃不下"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "是否有以下情况",
        "options": ["正常", "口中异味","打嗝","反酸","恶心","腹胀","腹痛","食道烧灼感","胃有烧心感","口唇干燥","涎唾过多"],
        "picked": [],
      }, {
        "questionType": "text",
        "question": "其他补充说明",
        "options": [],
        "picked": [],
        "text": "",
        "placeholder": "如有其他饮食方面的情况，请补充说明"
      }]
    },
    {
      "questionsType": "二便情况",
      "questionList": [{
        "questionType": "radio",
        "question": "大便",
        "options": ["一日一次", "一日多次","多日一次", "长期便秘","长期腹泻","饭后即泻","晨起即泻", "不确定"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "形状",
        "options": ["球形", "细条状","不成形","正常", "不确定"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "质地",
        "options": ["偏干", "偏稀","黏马桶","水样便","未消化的食物","正常", "不确定"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "大便颜色",
        "options": ["黑", "白","青","黄", "不确定"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "便血",
        "options": ["长期有", "偶尔有","无", "不确定"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "是否有以下情况",
        "options": ["放屁多", "放屁臭","大便很臭","大便时肛门有灼热感","大便时肛门有疼痛感","大便不爽(不畅快，没有拉干净)","无以上情况", "不确定"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "小便",
        "options": ["次数偏多", "次数偏少","尿量偏多","尿量偏少","尿急","遗尿","尿不尽","小便时尿道灼热","小便时尿道涩痛","尿血","味道大","正常", "不确定"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "小便颜色",
        "options": ["酱油色", "浓茶色","深黄色","淡黄色","红色","绿色","黑色","白色", "不确定"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "小便质地",
        "options": ["澄清", "浑浊", "不确定"],
        "picked": [],
      }, {
        "questionType": "text",
        "question": "其他补充说明",
        "options": [],
        "picked": [],
        "text": "",
        "placeholder": "如有其他二便的情况，请补充说明"
      }]
    },
    {
      "questionsType": "睡眠与情绪",
      "questionList": [{
        "questionType": "radio",
        "question": "入睡",
        "options": ["困难", "容易"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "质量",
        "options": ["睡眠深", "睡眠浅","周期性失眠"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "夜醒常出现在",
        "options": ["23-1点", "1-3点","3-5点","5-7点","无"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "醒后是否还能入睡",
        "options": ["很难", "难","容易"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "梦",
        "options": ["长期多梦", "偶尔多梦","少梦","无梦"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "是否有以下情况",
        "options": ["醒后依然困乏", "白天犯困","午后犯困","饭后犯困","全天精神疲倦","想睡但睡不着","睡觉时流口水","无以上情况"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "情绪",
        "options": ["易发怒", "易悲伤","易烦躁","易抑郁","易忘事","易焦虑","易受惊","喜欢热闹","喜欢安静","爱叹气","心态平和，无以上情况"],
        "picked": [],
      }, {
        "questionType": "text",
        "question": "其他补充说明",
        "options": [],
        "picked": [],
        "text": "",
        "placeholder": "如有其他睡眠与情绪方面的情况，请补充说明"
      }]
    },
    {
      "questionsType": "身体感觉",
      "questionList": [{
        "questionType": "radio",
        "question": "整体寒热",
        "options": ["怕冷", "怕热","怕风","忽冷忽热","潮热","上身热下身冷","上身冷下身热","正常"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "手脚寒热",
        "options": ["手偏冷", "脚偏冷","手偏热","脚偏热","手脚心热","正常"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "出汗（身体潮润感即算出汗）",
        "options": ["安静时即易出汗", "稍活动即大汗淋漓","基本不出汗","手心出汗明显","脚心出汗明显","半身出汗","仅头部出汗","盗汗（睡时出汗，醒后即止）","正常"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "头面五官是否有以下情况",
        "options": ["头痛", "头昏","眩晕","视物模糊","眼睛干涩","眼睛疼痛","耳鸣","听力下降","耳聋","鼻干","鼻痒","鼻痛","鼻塞","清涕","浊涕","呼吸热烫","易流鼻血","咽干","咽痒","咽肿","咽痛","咽部异物感","无以上情况"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "咳嗽和痰",
        "options": ["咳嗽", "喘息","痰少","痰多","黄痰","白痰","黄白痰","痰中带血","痰黏稠","痰清稀","痰涎咳吐不出","无以上情况"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "胸腹部是否有以下情况",
        "options": ["心慌", "胸闷","气短","胸部胀满","胸骨按痛","两胁胀痛","胃胀","胃痛","腹胀（除胃以外的部位）","腹痛（除胃以外的部位）","腹部坚硬","有气从腹部上冲","无以上情况"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "脊柱四肢是否有以下情况",
        "options": ["颈肩拘紧疼痛", "后背拘紧疼痛","腰酸","腰痛","身体困重","身痒","四肢疼痛","四肢无力","四肢屈伸不利","身体转侧不利","睡觉时四肢抽动","足跟痛","脚踩棉花感","身体乏力","无以上情况"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "生活习惯",
        "options": ["饮食不规律", "饮食不节制","饮食不干净","贪食辛辣","贪食油腻","贪食生冷","饮食过咸","饮食过甜","长期嗜酒","长期吸烟","长期熬夜","久坐","久站","久卧","运动过量","房事过频","频繁手淫","无以上情况"],
        "picked": [],
      }, {
        "questionType": "text",
        "question": "其他补充说明",
        "options": [],
        "picked": [],
        "text": "",
        "placeholder": "如有其他身体感觉方面的情况，请补充说明"
      }]
    },
  ],
  "male": [
    {
      "questionsType": "男科",
      "questionList": [{
        "questionType": "mulitple",
        "question": "性功能",
        "options": ["早泄","阳痿", "晨勃消失","频繁遗精","频繁滑精","无以上情况"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "男科问题",
        "options": ["不育", "前列腺肥大","前列腺炎","尿道炎","附睾炎","睾丸炎","无以上情况"],
        "picked": [],
      }, {
        "questionType": "text",
        "question": "其他补充说明",
        "options": [],
        "picked": [],
        "text": "",
        "placeholder": "如有其他男科方面的情况，请补充说明"
      }]
    }
  ],
  "female": [
    {
      "questionsType": "妇科",
      "questionList": [{
        "questionType": "radio",
        "question": "特殊阶段",
        "options": ["备孕", "孕期","哺乳期", "经期","绝经前后","子宫及附件全部摘除","子宫及附件部分摘除","非特殊阶段"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "生育",
        "options": ["无", "1次","2次及以上"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "流产",
        "options": ["无", "1次","2次及以上"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "是否绝经",
        "options": ["是", "否"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "经期",
        "options": ["月经提前", "月经延后","月经前后不定期","月经规律"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "经量",
        "options": ["多","少","一般"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "经色",
        "options": ["暗黑","褐色","鲜红","淡红"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "血块",
        "options": ["有","无"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "痛经",
        "options": ["轻度","重度","无"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "白带量",
        "options": ["多","少","一般"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "白带颜色质地",
        "options": ["无色或白色","脓性","血性","豆腐渣样"],
        "picked": [],
      }, {
        "questionType": "mulitple",
        "question": "经前感觉",
        "options": ["乳痛","腰酸","小腹坠胀","头痛","恶心呕吐","无以上情况"],
        "picked": [],
      }, {
        "questionType": "text",
        "question": "其他补充说明",
        "options": [],
        "picked": [],
        "text": "",
        "placeholder": "如有其他妇科方面的情况，请补充说明"
      }]
    }
  ],
  "femaleWesten": [
    {
      "questionsType": "妇科",
      "questionList": [{
        "questionType": "radio",
        "question": "经量",
        "options": ["多", "少","一般"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "经血颜色",
        "options": ["暗黑", "褐色","鲜红", "淡红"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "血块",
        "options": ["有", "无"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "行经时",
        "options": ["腹痛", "腰部酸痛","乳房胀痛", "无以上情况"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "带下的量",
        "options": ["无", "多","中", "少"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "颜色",
        "options": ["无色", "白","黄", "绿", "褐", "红"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "质地",
        "options": ["清稀", "黏稠","豆腐渣样"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "异味",
        "options": ["有", "无"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "阴部的瘙痒、疼痛",
        "options": ["有", "无"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "怀孕次数",
        "options": ["无", "1 次","2 次及以上"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "生产次数",
        "options": ["无", "1 次","2 次及以上"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "生产方式",
        "options": ["自然分娩", "剖宫产","以上均有"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": " 流产次数",
        "options": ["无", "1 次","2 次及以上"],
        "picked": [],
      }, {
        "questionType": "radio",
        "question": "流产方式",
        "options": ["自然流产", "人工流产","药物流产","以上均有"],
        "picked": [],
      }]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config/questionnaire.js